
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1428|4154|5366|7540|8792|9146|9844)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
